"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _AbstractElement = _interopRequireDefault(require("UIComponents/elements/AbstractElement"));

var _UIClickable = _interopRequireDefault(require("UIComponents/button/UIClickable"));

var _Checkbox = _interopRequireDefault(require("./Checkbox"));

var _UnstyledNestedNavItem = _interopRequireDefault(require("./UnstyledNestedNavItem"));

var getOpenIcon = function getOpenIcon(open) {
  return open ? 'up' : 'down';
};

var NestedNavCheckboxItem = function NestedNavCheckboxItem(_ref) {
  var checkboxProps = _ref.checkboxProps,
      children = _ref.children,
      className = _ref.className,
      defaultOpen = _ref.defaultOpen,
      title = _ref.title,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["checkboxProps", "children", "className", "defaultOpen", "title"]);
  var onChange = checkboxProps.onChange;

  var _useState = (0, _react.useState)(defaultOpen),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  var itemClasses = (0, _classnames.default)('p-y-0', className, {
    'display-flex align-center': !!children
  });
  var handleChange = (0, _react.useCallback)(function (evt) {
    var checked = evt.target.checked;

    if (onChange) {
      onChange(evt);
    }

    if (!evt.defaultPrevented && checked) {
      setOpen(true);
    }
  }, [onChange]);

  var handleClick = function handleClick(evt) {
    evt.stopPropagation();
  };

  var handleOpenChange = function handleOpenChange(_ref2) {
    var value = _ref2.target.value;
    setOpen(value);
  };

  var renderedTitle = children ? _react.default.createElement(_UIClickable.default, {
    onClick: function onClick(evt) {
      evt.preventDefault();
      setOpen(!open);
    }
  }, title) : title;
  return _react.default.createElement(_UnstyledNestedNavItem.default, (0, _extends2.default)({}, rest, {
    _linkComponent: _AbstractElement.default,
    className: itemClasses,
    iconRight: children != null ? getOpenIcon(open) : null,
    onOpenChange: handleOpenChange,
    open: open,
    title: _react.default.createElement(_Checkbox.default, (0, _extends2.default)({}, checkboxProps, {
      onChange: handleChange,
      onClick: handleClick
    }), renderedTitle)
  }), children);
};

NestedNavCheckboxItem.propTypes = {
  checkboxProps: _propTypes.default.shape({
    onChange: _propTypes.default.func
  }),
  children: _propTypes.default.node,
  className: _propTypes.default.string,
  defaultOpen: _propTypes.default.bool,
  title: _propTypes.default.node.isRequired
};
NestedNavCheckboxItem.defaultProps = {
  checkboxProps: {},
  defaultOpen: false
};
var _default = NestedNavCheckboxItem;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/storefront/sidebar/inputs/NestedNavCheckboxItem.js
// module id = 263
// module chunks = 209 210 211 212